import type { IProjectReportRepository } from '../repositories/IProjectReportRepository.js';
import type { ReportFormxItem } from '../entities/ProjectReportRowEntity.js';

interface Deps { projectReportRepository: IProjectReportRepository; }

export function createGetSessionFormxDetailUseCase({ projectReportRepository }: Deps) {
  return async function getSessionFormxDetail(
    orgId: string,
    sessionId: string,
  ): Promise<ReportFormxItem[]> {
    return projectReportRepository.getSessionFormxDetail(orgId, sessionId);
  };
}
